var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 43C33.598 43 43 33.598 43 22C43 10.402 33.598 1 22 1C10.402 1 1 10.402 1 22C1 33.598 10.402 43 22 43Z",
    fill: "#E6F4F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 29.5833C16.927 28.8073 17.8346 28.1907 18.8363 27.7698C19.8379 27.3489 20.9135 27.1321 22 27.1321C23.0865 27.1321 24.1621 27.3489 25.1637 27.7698C26.1654 28.1907 27.073 28.8073 27.8333 29.5833",
    fill: "#E6F4F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.3333H15.0233M29 17.3333H29.0233M16.1667 29.5833C16.927 28.8073 17.8346 28.1907 18.8363 27.7698C19.8379 27.3489 20.9135 27.1321 22 27.1321C23.0865 27.1321 24.1621 27.3489 25.1637 27.7698C26.1654 28.1907 27.073 28.8073 27.8333 29.5833M43 22C43 33.598 33.598 43 22 43C10.402 43 1 33.598 1 22C1 10.402 10.402 1 22 1C33.598 1 43 10.402 43 22Z",
    stroke: "#0091B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad-face.4b1a4026135060688e3a3e3c31edfac0.svg";
export { ForwardRef as ReactComponent };